<template>
  <div class="p-16px">
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      title="紫金山骑手机构端 · 邀请码审骑手入驻 / 派单（骑手入驻机构）。骑手填码与接拒在「紫金山骑手端」App。"
    />
    <el-form inline class="mb-12px">
      <el-form-item label="机构 ID">
        <el-input v-model="orgId" class="!w-140px" />
      </el-form-item>
      <el-button type="primary" @click="refresh">刷新</el-button>
    </el-form>

    <el-row :gutter="16">
      <el-col :span="12">
        <el-card shadow="never" header="邀请码与入驻审核">
          <p class="mb-8px">
            邀请码：
            <strong class="text-16px">{{ inviteCode || '—' }}</strong>
            <el-button class="ml-8px" size="small" :disabled="!inviteCode" @click="copyInvite">
              复制
            </el-button>
            <el-button size="small" type="warning" @click="onRotate">重置码</el-button>
          </p>
          <el-table :data="joins" size="small" border>
            <el-table-column prop="phone" label="手机号" width="120" />
            <el-table-column prop="status" label="状态" width="90" />
            <el-table-column label="操作" min-width="140">
              <template #default="{ row }">
                <template v-if="row.status === 'pending'">
                  <el-button link type="success" @click="onDecide(row.joinId, 'approve')">
                    通过
                  </el-button>
                  <el-button link type="danger" @click="onDecide(row.joinId, 'reject')">
                    拒绝
                  </el-button>
                </template>
                <span v-else class="text-12px">{{ row.rejectReason || '—' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never" header="派单">
          <el-form label-width="80px">
            <el-form-item label="运单号">
              <el-input v-model="waybillId" placeholder="平台造 org_dispatch 单" />
            </el-form-item>
            <el-button type="primary" :disabled="!waybillId" @click="onOffer">
              派给在线机构骑
            </el-button>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts" setup>
import * as OrgConsoleApi from '@/api/capacity/org-console'
import { ElMessage } from 'element-plus'

defineOptions({ name: 'MerchantCapacityInvite' })

const orgId = ref(localStorage.getItem('capacityOrgId') || '')
const inviteCode = ref('')
const joins = ref<OrgConsoleApi.JoinItem[]>([])
const waybillId = ref('')

const refresh = async () => {
  if (!orgId.value) return
  const o = await OrgConsoleApi.orgInvite(orgId.value)
  inviteCode.value = o.inviteCode || ''
  joins.value = await OrgConsoleApi.orgJoins(orgId.value, false)
}

const copyInvite = async () => {
  if (!inviteCode.value) return
  await navigator.clipboard.writeText(inviteCode.value)
  ElMessage.success('已复制')
}

const onRotate = async () => {
  const r = await OrgConsoleApi.orgRotateInvite(orgId.value)
  if (!r.success) {
    ElMessage.error(r.message || '重置失败')
    return
  }
  ElMessage.success('已重置，待审已作废')
  await refresh()
}

const onDecide = async (joinId: string, decision: 'approve' | 'reject') => {
  const r = await OrgConsoleApi.orgDecideJoin({
    orgId: orgId.value,
    joinId,
    decision,
    reason: decision === 'reject' ? '不符合要求' : undefined
  })
  if (!r.success) {
    ElMessage.error(r.message || '操作失败')
    return
  }
  ElMessage.success(decision === 'approve' ? '已通过' : '已拒绝')
  await refresh()
}

const onOffer = async () => {
  const r = await OrgConsoleApi.orgOfferDispatch(waybillId.value.trim())
  if (!r.success) {
    ElMessage.error((r.code ? `[${r.code}] ` : '') + (r.message || '派单失败'))
    return
  }
  ElMessage.success('已派单，请到骑手 App 接拒')
}

onMounted(async () => {
  if (!orgId.value) {
    try {
      const mine = await OrgConsoleApi.orgMyApply()
      if (mine?.orgId && mine.status === 'active') {
        orgId.value = mine.orgId
        localStorage.setItem('capacityOrgId', mine.orgId)
      }
    } catch {
      /* ignore */
    }
  }
  if (orgId.value) await refresh()
})
</script>
